import React, { FC } from "react";
import { IProps } from "./types";
import styles from "./styles.module.scss";
import { CrossIcon } from "../../assets";

const Tag: FC<IProps> = ({
  title,
  withCounter = false,
  counter = 0,
  onPress,
}): JSX.Element => {
  return (
    <div
      onClick={onPress}
      className={onPress ? styles.touchableWrapper : styles.wrapper}
    >
      <span>{title}</span>
      {onPress ? <CrossIcon /> : null}
    </div>
  );
};

export default Tag;
